import api from './api';

const botService = {
  // Get bot connection status
  getBotStatus: async () => {
    const response = await api.get('/bot/status');
    return response.data;
  },

  // Get current bot configuration
  getBotConfig: async () => {
    const response = await api.get('/bot/config');
    return response.data;
  },

  // Update bot configuration
  updateBotConfig: async (config) => {
    const response = await api.put('/bot/config', config);
    return response.data;
  },

  // Reload bot configuration
  reloadBotConfig: async () => {
    const response = await api.post('/bot/reload');
    return response.data;
  },

  // ================================
  // B站账号扫码登录相关
  // ================================

  // 生成登录二维码
  generateQRCode: async () => {
    const response = await api.post('/bilibili/qrcode/generate');
    return response.data;
  },

  // 轮询二维码状态
  pollQRCodeStatus: async (qrcodeKey) => {
    const response = await api.get(`/bilibili/qrcode/poll/${qrcodeKey}`);
    return response.data;
  },

  // 验证Cookie是否有效
  validateCookie: async (cookie) => {
    const response = await api.post('/bilibili/qrcode/validate', { cookie });
    return response.data;
  },

  // ================================
  // 房间B站账号管理
  // ================================

  // 保存房间的B站账号
  saveRoomBilibiliAccount: async (roomUid, accountData) => {
    const response = await api.post(`/bot/room/${roomUid}/bilibili-account`, accountData);
    return response.data;
  },

  // 获取房间的B站账号信息
  getRoomBilibiliAccount: async (roomUid) => {
    const response = await api.get(`/bot/room/${roomUid}/bilibili-account`);
    return response.data;
  },

  // 删除房间的B站账号
  deleteRoomBilibiliAccount: async (roomUid) => {
    const response = await api.delete(`/bot/room/${roomUid}/bilibili-account`);
    return response.data;
  },

  getRoomAiCredential: async (roomUid, provider = 'deepseek') => {
    const response = await api.get(`/bot/room/${roomUid}/ai-credential`, {
      params: { provider }
    });
    return response.data;
  },

  saveRoomAiCredential: async (roomUid, credentialData) => {
    const response = await api.post(`/bot/room/${roomUid}/ai-credential`, credentialData);
    return response.data;
  },

  deleteRoomAiCredential: async (roomUid, provider = 'deepseek') => {
    const response = await api.delete(`/bot/room/${roomUid}/ai-credential`, {
      params: { provider }
    });
    return response.data;
  }
};

export default botService;
